import { AccountItemEnum } from '../../../../../../../../../modules/mobile/modals/profile';

export default {
  title: 'Cuenta',
  items: {
    [AccountItemEnum.ManageAccount]: {
      title: 'Gestionar cuenta',
      description: 'Mantén tu cuenta actualizada y administra tu configuración.',
    },
    [AccountItemEnum.PaymentMethods]: {
      title: 'Métodos de pago',
      description: 'Añade, cambia o selecciona tu método de pago preferido.',
    },
    [AccountItemEnum.HelpAndFAQs]: {
      title: 'Ayuda y preguntas frecuentes',
    },
    [AccountItemEnum.Logout]: {
      title: 'Cerrar sesión',
    },
    [AccountItemEnum.Language]: {
      title: 'Idioma',
    },
  },
};
